import { makeStyles } from "@material-ui/core";
import { PaletteColor } from "@material-ui/core/styles/createPalette";
import { ClassNameMap } from "@material-ui/core/styles/withStyles";
import { cardWidth } from "../containers/layout/layout-styles";

export const tableText = "#969392";
export const mainContrast = "#d7e5fd";
export const bg = "#F5EFE8";
export const boxShadow = "0px 0 8px rgba(0, 0, 0, 0.08)";
export const bgInputs = "#F5F8F9";
export const purple = "#614faa";
export const purpleContrast = "#daddfe";
export const blue = "#7ea6b4";
export const lightBlue = "#7ea6b426";
export const blueContrast = "#cddcdc";
export const iconMain = "#fbfcfd";
export const blueContrastWithOpacity = "rgba(205, 220, 220, 0.2)";
export const sky = "#007178";
export const skyContrast = "#ccf6f2";
export const calendarBackground = "#d7e5fd";
export const summaryRowBackground = "#f2fef6";
export const mWidth = 1280;
export const minWidth = `${mWidth}px`;
export const rain = "#a8afff";
export const grassGreen = "#c6dbb7";
export const summaryCaption = "#bf3e93";
export const ocean = "#0b5a65";
export const scrollTrack = "#367bf5";
export const primaryActive = "#367bf5";
export const barWithinRange = "#c3d8fc";
export const barOutOfRange = "#f0f5f5";
export const river = "#f5f8f9";
export const pansies = "#daddfe";
export const positiveDelta = "#038331";
export const negativeDelta = "#EA8DA9";
export const oil = "#212121";
export const swamp = "#82a469";
export const salad = "#c6dbb7";
export const tree = "#4c7057";
export const fresh = "#e8f3d9";
export const dark = "#000000DE";
export const buttonHover = "rgba(54, 123, 245, 0.04)";
export const tableIdMinWidth = "150px";
export const buttonBackground = "rgba(54, 123, 245, 0.2)";
export const buttonBackgroundLite = "rgba(54, 123, 245, 0.1)";
export const supportColor = "#e3b340";
export const brightGray = "#5e6e7d";
export const disabledGray = "#B6B8B9";

export const useMapThemeClasses = () => {
	return v2();
};

const v2: (props?: any) => ClassNameMap<V2Types> = makeStyles(
	({ palette, spacing, zIndex, shape }) => {
		const tabItem = {
			padding: spacing(1),
			paddingLeft: spacing(7),
			paddingRight: spacing(7),
		};

		return {
			layoutRoot: {
				minWidth,
				minHeight: "100vh",
			},
			layoutContainer: {
				padding: "0px 72px",
			},
			breadCrumbRoot: {
				top: spacing(9),
				paddingTop: spacing(2),
				paddingBottom: spacing(1.5),
				marginBottom: spacing(0.25),
				paddingLeft: spacing(9),
				boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.08)",
				backgroundColor: "#fff",
			},
			appBarBg: {
				backgroundColor: "#FFFFFF",
				zIndex: zIndex.drawer + 1,
				boxShadow,
			},
			avatar: {
				backgroundColor: palette.warning.light,
				color: palette.warning.dark,
				border: `1px solid ${palette.warning.dark}`,
			},
			tabContainer: {
				marginTop: "54px",
				borderRadius: "0 4px 4px 4px",
				boxShadow: boxShadow,
			},
			tabRoot: {
				marginTop: "-54px",
			},
			tabIndicator: {
				display: "none",
			},
			tabTitle: {
				width: "100%",
				display: "flex",
				boxShadow: "-3px 0 5px -3px rgba(0, 0, 0, 0.08)",
				position: "relative",
				"& button": {
					whiteSpace: "nowrap",
					maxWidth: "330px",
				},
			},
			tabActiveTitle: {
				...tabItem,
				color: palette.primary.main,
				textTransform: "capitalize",
				fontSize: "1.375rem",
				fontWeight: 600,
				backgroundColor: "white",
				borderRadius: "4px 4px 0 0",
				boxShadow: boxShadow,
			},
			tabInactive: {
				...tabItem,
				backgroundColor: bgInputs,
				textTransform: "capitalize",
				fontSize: "1.375rem",
				fontWeight: 300,
				borderRadius: "4px 4px 0 0",
				opacity: 1,
				color: "#969392",
			},
			tabsContainer: {
				display: "contents",
			},
			paper: {
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				backgroundColor: palette.background.paper,
				width: "100%",
			},
			search: {
				backgroundColor: bgInputs,
				height: "40px",
				minWidth: "270px",
				borderRadius: "4px",
				"& .MuiOutlinedInput-notchedOutline": {
					borderColor: bgInputs,
				},
				"&:hover .MuiOutlinedInput-notchedOutline": {
					borderColor: palette.primary.main,
				},
			},
			selectedItem: {
				borderRadius: shape.borderRadius,
				marginLeft: spacing(0.1),
				"&:hover": {
					color: palette.primary.main,
					backgroundColor: "rgba(55, 125, 246, 0.05)",
				},
				marginRight: -spacing(0.1),
				paddingLeft: spacing(3),
				paddingRight: spacing(3),
				paddingBottom: spacing(1.63),
				paddingTop: spacing(1.75),
			},
			navBarBold: {
				fontWeight: 800,
				color: palette.primary.main,
				fontSize: "22px",
			},
			navBarHover: {
				color: (palette.tableText as PaletteColor).main || tableText,
				"&:hover": {
					color: palette.primary.main,
				},
				fontSize: "22px",
				fontWeight: 600,
			},
			br10: {
				borderRadius: "10px",
				boxShadow,
				border: "none",
			},
			br: {
				borderRadius: "4px",
			},
			selectedNavBar: {
				backgroundColor: palette.background.paper,
				color: palette.primary.main,
			},
			unSelectedNavBar: {
				color: palette.tableText.main,
				backgroundColor: palette.inputTableDivider.main,
			},
			squareButton: {
				borderRadius: "5px",
				color: palette.primary.main,
				padding: "5px",
				"&:hover": {
					backgroundColor: palette.background.paper,
				},
			},
			buttonHover: {
				"&:hover": {
					backgroundColor: palette.background.paper,
				},
			},
			fab: {
				position: "fixed",
				bottom: spacing(3),
				right: spacing(3),
				backgroundColor: palette.primary.main,
				color: "white",
				"&:hover, &.Mui-focusVisible": {
					backgroundColor: palette.primary.light,
				},
				width: "154px",
				zIndex: 1,
				display: "flex",
				justifyContent: "space-between",
			},
			bgPrimLight: {
				backgroundColor: "rgba(54, 123, 245, 0.2)",
			},
			container: {
				backgroundColor: palette.background.paper,
				borderRadius: "4px",
				marginTop: spacing(15),
				paddingTop: spacing(4),
				paddingBottom: spacing(6),
				minWidth: cardWidth,
			},
			publicAgreementInfo: {
				width: "100%",
				margin: "-16px 0 24px 0",
				backgroundColor: summaryRowBackground,
				padding: "15px 40px",
				color: "#333333",
			},
		};
	},
	// @ts-ignore
	{ index: 999 }
);

const v2Types = Object.keys(v2);
type V2Types = (typeof v2Types)[number];
